// Wspólne komunikaty blokady startu gry — pokazywane gdy backend zwróci 409
// przy próbie uruchomienia gry. Render w stylu memory (czysty ekran w modalu
// + „Zamknij"), wspólny dla wszystkich gier dziennych — modułowych i silnikowych.

// Inna gra wciąż aktywna / poprzednia gra zamknięta nieprawidłowo (game_in_progress).
export const GAME_BLOCKED_MESSAGE =
    'Zarejestrowaliśmy nieprawidłowe zamknięcie\n'
    + 'poprzedniej gry. Kolejną grę będzie można uruchomić\n'
    + 'za jakiś czas. Zajrzyj do nas później.';

// Ta konkretna gra została już rozegrana / próba została zużyta (already_completed).
export const GAME_ALREADY_PLAYED_MESSAGE = 'Ta gra została już rozegrana.';

/**
 * Mapuje klucz błędu 409 na właściwy komunikat.
 *
 * @param {string} errorKey wartość pola `error` z odpowiedzi 409
 * @returns {string}
 */
export function startBlockedMessage(errorKey) {
    return errorKey === 'already_completed'
        ? GAME_ALREADY_PLAYED_MESSAGE
        : GAME_BLOCKED_MESSAGE;
}

/**
 * Wstrzykuje ekran komunikatu do treści modala gry.
 *
 * @param {HTMLElement} modal element `.game-modal`
 * @param {string} msg treść komunikatu (domyślnie GAME_BLOCKED_MESSAGE)
 */
export function renderGameMessage(modal, msg = GAME_BLOCKED_MESSAGE) {
    const content = modal?.querySelector('.game-modal__content');
    if (!content) return;

    const wrap = document.createElement('div');
    wrap.className = 'game-modal__inner game-modal__notice';

    const box = document.createElement('div');
    box.className = 'game-modal__notice-box';

    const text = document.createElement('p');
    text.className = 'game-modal__notice-text';
    text.textContent = msg;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'game-modal__notice-btn js-game-close-results';
    btn.textContent = 'Zamknij';

    box.append(text, btn);
    wrap.append(box);

    content.innerHTML = '';
    content.append(wrap);
}
